import type {
  CreditHistoryModalViewedProperties,
  HotelTappedListCardProperties,
  OffersEntryProperties,
  TappedOfferBannerProperties,
  TappedOfferModalCtaProperties,
  TappedOfferSearchProperties,
  TappedOfferTileProperties,
  TappedSeeAllHotelsProperties,
  ViewedAllOffersProperties,
  ViewedOfferBannerProperties,
  ViewedOfferDetailsModalProperties,
  ViewedOfferTileProperties,
  WalletViewedProperties,
} from "../raw/OfferRawEvent";

export enum RbcOfferEventName {
  viewed_offer_banner = "viewed_offer_banner",
  tapped_offer_banner = "tapped_offer_banner",
  viewed_offer_tile = "viewed_offer_tile",
  tapped_offer_tile = "tapped_offer_tile",
  viewed_offer_details_modal = "viewed_offer_details_modal",
  tapped_offer_modal_cta = "tapped_offer_modal_cta",
  offers_entry = "offers_entry",
  tapped_offer_search = "tapped_offer_search",
  hotel_tapped_list_card = "hotel_tapped_list_card",
  tapped_see_all_hotels = "tapped_see_all_hotels",
  wallet_viewed = "wallet_viewed",
  credit_history_modal_viewed = "credit_history_modal_viewed",
  viewed_all_offers = "viewed_all_offers",
}

export interface ViewedOfferBannerEvent {
  name: RbcOfferEventName.viewed_offer_banner;
  properties: ViewedOfferBannerProperties;
}

export interface TappedOfferBannerEvent {
  name: RbcOfferEventName.tapped_offer_banner;
  properties: TappedOfferBannerProperties;
}

export interface ViewedOfferTileEvent {
  name: RbcOfferEventName.viewed_offer_tile;
  properties: ViewedOfferTileProperties;
}

export interface TappedOfferTileEvent {
  name: RbcOfferEventName.tapped_offer_tile;
  properties: TappedOfferTileProperties;
}

export interface ViewedOfferDetailsModalEvent {
  name: RbcOfferEventName.viewed_offer_details_modal;
  properties: ViewedOfferDetailsModalProperties;
}

export interface TappedOfferModalCtaEvent {
  name: RbcOfferEventName.tapped_offer_modal_cta;
  properties: TappedOfferModalCtaProperties;
}

export interface OffersEntryEvent {
  name: RbcOfferEventName.offers_entry;
  properties: OffersEntryProperties;
}

export interface TappedOfferSearchEvent {
  name: RbcOfferEventName.tapped_offer_search;
  properties: TappedOfferSearchProperties;
}

export interface HotelTappedListCardEvent {
  name: RbcOfferEventName.hotel_tapped_list_card;
  properties: HotelTappedListCardProperties;
}

export interface TappedSeeAllHotelsEvent {
  name: RbcOfferEventName.tapped_see_all_hotels;
  properties: TappedSeeAllHotelsProperties;
}

export interface WalletViewedEvent {
  name: RbcOfferEventName.wallet_viewed;
  properties: WalletViewedProperties;
}

export interface CreditHistoryModalViewedEvent {
  name: RbcOfferEventName.credit_history_modal_viewed;
  properties: CreditHistoryModalViewedProperties;
}

export interface ViewedAllOffersEvent {
  name: RbcOfferEventName.viewed_all_offers;
  properties: ViewedAllOffersProperties;
}

export type OfferEvent =
  | ViewedOfferBannerEvent
  | TappedOfferBannerEvent
  | ViewedOfferTileEvent
  | TappedOfferTileEvent
  | ViewedOfferDetailsModalEvent
  | TappedOfferModalCtaEvent
  | OffersEntryEvent
  | TappedOfferSearchEvent
  | HotelTappedListCardEvent
  | TappedSeeAllHotelsEvent
  | WalletViewedEvent
  | CreditHistoryModalViewedEvent
  | ViewedAllOffersEvent;
